import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import serverHost from "../../services/serverHost";
import pedidoEvento from "../../enums/pedidoEvento";
import Form from "../../components/form";
import ActionTable from "../../components/table/ActionTable";
import Edicao from "./Edicao";
import {
  IconButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

const dataAtual = new Date();
const mesAtual = dataAtual.getMonth() + 1;
const anoAtual = dataAtual.getFullYear();

export default function Pedido(props) {
  const [pedidoId] = useState(Number(props.match.params.id));
  const { notification } = useContext(AppContext);
  const [pedido, setPedido] = useState({});
  const [edicaoPermitida, setEdicaoPermitida] = useState(false);
  const [eventoSelecionado, setEventoSelecionado] = useState({});
  const [selecaoEdicao, setSelecaoEdicao] = useState(false);
  const [modoGerenciamentoPagamentos, setModoGerenciamentoPagamentos] = useState(false);
  const [registroPgtoExterno, setRegistroPgtoExterno] = useState(false);
  const [dadosRegistroPgtoExterno, setDadosRegistroPagtoExterno] = useState({
    operacao: 1,
    opcaoParcelamento: 1
  });
  const [elementoEdicao, setElementoEdicao] = useState("");
  const [tiposEventos, setTiposEventos] = useState([]);
  const [pagamentoExternoCancelar, setPagamentoExternoCancelar] = useState(false);
  const history = props.history;

  useEffect(() => {
    carregarPedido();
  }, []);

  const carregarPedido = () => {
    api
      .get("pedidos/carregar", { id: pedidoId })
      .then((pedido) => {
        pedido.valorTotalItens = 0;

        pedido.itens = pedido.itens.filter((item) => item.pedidoItemQtd > 0);

        pedido.itens.forEach((pi) => {
          pi.valorUnitario = `R$ ${
            pi.pedidoItemValor ? pi.pedidoItemValor.toFixed(2) / 100 : 0
          }`;
          pi.valorTotal = `R$ ${
            pi.pedidoItemValor
              ? ((pi.pedidoItemValor * pi.pedidoItemQtd) / 100).toFixed(2)
              : 0
          }`;

          pedido.valorTotalItens += pi.pedidoItemValor * pi.pedidoItemQtd;
        });

        pedido.eventos.forEach((evento) => {
          evento.anexoUrl = evento.pedidoEventoAnexo
            ? `${serverHost()}/${evento.pedidoEventoAnexo}`
            : "";
        });        
        
        const edicaoPermitida = !pedido.faturaFechadaFaturaEscolaId;

        pedido.pagamentos.forEach((pp) => {
          pp.data = `${pp.mes}/${pp.ano}`;
          pp.valor = `R$ ${(pp.valor / 100).toFixed(2)}`;

          if(pp.pagamentoExternoOperacao){
            pp.situacao = pp.pagamentoDesconto ? 'Desconto' : 'Pagamento externo';

            if(pp.pagamentoExternoObservacao) pp.situacao += ` (${pp.pagamentoExternoObservacao})`;

            pp.situacao = (
              <div>
                {pp.situacao}
                <IconButton
                  key={1}
                  title={'Desfazer'}
                  style={{ color: 'red' }}
                  onClick={() => setPagamentoExternoCancelar(pp.id)}
                >
                  <i className="zmdi zmdi-smartphone-erase"></i>
                </IconButton>
              </div>
            )
          } else {
            pp.situacao = pp.faturaPagamento ? 
              "Pago" : 
              (pp.pagamentoDiretoPagamento ? 
                `Pago (fatura IUGU ${pp.pagamentoDiretoFaturaIuguId})` : "Pendente"
              );
          }

          if([1, 2, 3].includes(pp.modalidade)){
            pedido.linkAcompanhamento = `https://escola.pertoeducacao.com.br/acompanhamento-pedido/${pedido.chaveAcompanhamento}`;
            pp.tipo = `Direto (${modalidesPagamento.find(m => m.value === pp.modalidade).desc})`;
          } else {
            pp.tipo = 'Faturas'
          }

          if(pp.anexoURL){
            pp.anexoURL = `${serverHost()}/${pp.anexoURL}`
          };
        });

        pedido.valorPendente = pedido.valorTotal - pedido.valorPago;

        if (!pedido.cancelamento) listarTiposEventos();

        setPedido(pedido);
        setEdicaoPermitida(edicaoPermitida);
      })
      .catch((e) => notification("error", "Erro ao carregar pedidos"));
  };

  const listarTiposEventos = () => {
    api
      .get("eventosPedido/listar")
      .then((tiposEventos) => {
        setTiposEventos(tiposEventos);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const salvar = (form) => {
    api
      .post("pedidos/atualizarCodigoNF", {
        pedidoId: pedido.id,
        codigoNF: form.codigoNF,
      })
      .then((res) => {
        notification("success", "Dados salvos com sucesso!");
        carregarPedido();
      })
      .catch((err) => {
        console.log(err);
        notification(
          "error",
          "Erro ao salvar o pedido. Verifique os dados e tente novamente."
        );
      });
  };

  const salvarDadosFormPagtoExterno = (campo, valor) => {
    const dadosRegistroPgtoExternoAtualizar = { ...dadosRegistroPgtoExterno };
    dadosRegistroPgtoExternoAtualizar[campo] = valor;

    setDadosRegistroPagtoExterno(dadosRegistroPgtoExternoAtualizar);
  };

  const registrarPagamentoExterno = form => {
    setDadosRegistroPagtoExterno(form);

    let valor = 0;

    if(!form.valor || form.valor <= 0){
      return notification('warning', 'Valor inválido');
    } else {
      valor = form.valor*100;
    }

    const data = new FormData();

    data.append("pedidoId", pedido.id);
    data.append("valor", valor);
    data.append("observacao", form.observacao);    
    data.append("operacao", form.operacao);

    if(dadosRegistroPgtoExterno.opcaoParcelamento === '2'){
      data.append("qtdParcelas", form.qtdParcelas);
      data.append("mes", form.mes);
      data.append("ano", form.ano);
    }    

    if (form.anexo && form.anexo[0]) data.append("anexo", form.anexo[0]);

    api
      .put("pedidos/registrarPagamentoExterno", data)
      .then((res) => {
        notification("success", "Pagamento registrado com sucesso!");
        carregarPedido();
        setDadosRegistroPagtoExterno({operacao: 1});
        setRegistroPgtoExterno(false);
        setModoGerenciamentoPagamentos(false);
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Valor inválido inválido");
          case 2:
            return notification("error", "O valor informado não pode ser superior ao valor total das parcelas pendentes do pedido.");
          default:
            return notification("error", "Não foi possível inserir o pagamento externo. Verifique os dados informados e tente novamente.");
        }
      });
  }

  const cancelarPagamentoExterno = () => {
    api
      .put("pedidos/cancelarPagamentoExterno", {pedidoId: pedido.id, pedidoPagamentoId: pagamentoExternoCancelar})
      .then((res) => {
        notification("success", "Pagamento externo/desconto cancelado.");
        carregarPedido();
        setDadosRegistroPagtoExterno({operacao: 1});
        setRegistroPgtoExterno(false);
        setModoGerenciamentoPagamentos(false);
        setPagamentoExternoCancelar(0);
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          default:
            return notification("error", "Não foi possível cancelar o pagamento externo/desconto.");
        }
      });
  }

  const fPedido = {
    title: "Pedido",
    form: {
      codigo: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Código</h4>
            <p>{pedido.id ? pedido.id.toString().padStart(5, "0") : ""}</p>
          </div>
        ),
      },
      dataHora: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Data/hora</h4>
            <p>{new Date(pedido.dataHora).toLocaleString("pt-BR")}</p>
          </div>
        ),
      },
      situacao: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Situação</h4>
            <p>{pedidoEvento.desc(pedido.situacao ? pedido.situacao : 0)}</p>
          </div>
        ),
      },
      codigoNF: {
        label: "Código NF",
        type: "number",
        space: 3,
        value: pedido.codigoNF,
      },
      valorItens: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Valor itens</h4>
            <p>
              {pedido.valorTotalItens
                ? `R$ ${(pedido.valorTotalItens / 100).toFixed(2)}`
                : "-"}
            </p>
          </div>
        ),
      },
      valorFrete: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Valor frete</h4>
            <p>
              {pedido.valorFrete
                ? `R$ ${(pedido.valorFrete / 100).toFixed(2)} (${
                    pedido.servicoFrete
                  })`
                : "-"}
            </p>
          </div>
        ),
      },
      valorTotal: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Valor total</h4>
            <p>{`R$ ${(pedido.valorTotal / 100).toFixed(2)}`}</p>
          </div>
        ),
      },
      numeroParcelas: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Quantidade de parcelas</h4>
            <p>{pedido.numeroParcelas}</p>
          </div>
        ),
      },
    },
    submit: {
      label: "Salvar",
      action: salvar,
    },
    history,
    close: true,
    customActions: [
      {
        label: "Editar pedido",
        action: () => setSelecaoEdicao(true),
      },
      {
        label: "Gerenciar pagamentos",
        action: () => setModoGerenciamentoPagamentos(true),
      },
    ],
  };

  if(pedido.linkAcompanhamento){
    fPedido.form.linkAcompanhamento = {
      label: "Componente",
      type: "component",
      space: 12,
      value: (
        <div>
          <h4>Link de acompanhamento direto</h4>
          <a href={pedido.linkAcompanhamento} target="_blank">
            {pedido.linkAcompanhamento}
          </a>
        </div>
      ),
    }
  }

  const fPedidoGerenciamentoPgto = {
    title: "Pedido",
    form: {
      codigo: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Código</h4>
            <p>{pedido.id ? pedido.id.toString().padStart(5, "0") : ""}</p>
          </div>
        ),
      },
      dataHora: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Data/hora</h4>
            <p>{new Date(pedido.dataHora).toLocaleString("pt-BR")}</p>
          </div>
        ),
      },
      escolaNome: {
        label: "Escola",
        type: "component",
        value: (
          <div>
            <h4>Escola</h4>
            <p>{pedido.escolaNome}</p>
          </div>
        ),
        space: 6
      },
      valorItens: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Valor itens</h4>
            <p>
              {pedido.valorTotalItens
                ? `R$ ${(pedido.valorTotalItens / 100).toFixed(2)}`
                : "-"}
            </p>
          </div>
        ),
      },
      valorFrete: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Valor frete</h4>
            <p>
              {pedido.valorFrete
                ? `R$ ${(pedido.valorFrete / 100).toFixed(2)} (${
                    pedido.servicoFrete
                  })`
                : "-"}
            </p>
          </div>
        ),
      },
      valorTotal: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Valor total</h4>
            <p>{`R$ ${(pedido.valorTotal / 100).toFixed(2)}`}</p>
          </div>
        ),
      },
      numeroParcelas: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Quantidade de parcelas</h4>
            <p>{pedido.numeroParcelas}</p>
          </div>
        ),
      },
    },
    submit: {
      label: "Salvar",
      action: salvar,
    },
    history,
    close: true,
    customActions: [
      {
        label: "Registrar pagamento externo/desconto",
        action: () => setRegistroPgtoExterno(true),
      },
    ],
  };

  const tRegistros = {
    title: "Itens",
    columns: [
      {
        name: "produtoNome",
        label: "Produto",
      },
      {
        name: "pedidoItemQtd",
        label: "Quantidade",
      },
      {
        name: "valorUnitario",
        label: "Valor unitário",
      },
      {
        name: "valorTotal",
        label: "Valor total",
      },
    ],
    array: pedido.itens,
  };

  const tbEventos = {
    title: "Eventos",
    array: pedido.eventos,
    columns: [
      {
        name: "eventoPedidoNome",
        label: "Evento",
      },
      {
        name: "pedidoEventoMomento",
        label: "Data/hora registro",
      },
      {
        name: "pedidoEventoOcorrencia",
        label: "Data/hora ocorrência",
      },
      {
        name: "pedidoEventoAnotacao",
        label: "Anotação",
      },
      {
        name: "pedidoEventoAnexoNome",
        label: "Anexo",
        link: "anexoUrl",
      },
    ],
    newItemAction: pedido.cancelamento
      ? undefined
      : () => setEventoSelecionado({ id: 0 }),
  };

  const tbPagamentos = {
    title: "Pagamentos",
    array: pedido.pagamentos,
    columns: [
      {
        name: "data",
        label: "Data",
      },
      {
        name: "valor",
        label: "Valor",
      },
      {
        name: "tipo",
        label: "Tipo"
      },
      {
        name: "situacao",
        label: "Situação",
      },
      {
        name: "anexoURL",
        label: "Anexo",
        link: "anexoURL",
      },
      {
        name: "remover",
        label: "",
        component: true
      }
    ],
  };

  const inserirEvento = (params) => {
    if (pedido.cancelamento)
      return notification(
        "warning",
        "Não é possível inserir evento em pedido cancelado."
      );

    const data = new FormData();

    const ocorrencia = `${params.data} ${params.hora}:${params.minuto}`;

    data.append("eventoPedidoId", params.eventoPedidoId);
    data.append("eventoDescricao", pedidoEvento.desc(Number(params.evento)));
    data.append("anotacao", params.anotacao);
    data.append("ocorrencia", ocorrencia);
    data.append("pedidoId", pedido.id);

    if (params.anexo && params.anexo[0]) {
      data.append("anexo", params.anexo[0]);
      data.append("anexoNome", params.anexo[0].name);
    }

    api
      .put("pedidos/inserirEvento", data)
      .then((res) => {
        notification("success", "Envento inserido com sucesso!");
        carregarPedido();
        setEventoSelecionado({});
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Evento inválido");
          case 2:
            return notification("error", "Pedido cancelado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fNovoEvento = {
    form: {
      eventoPedidoId: {
        label: "Último evento",
        type: "select",
        space: 4,
        // value: filtros.ultimoEvento,
        emptyItem: true,
        emptyItemText: "(Todas)",
        array: {
          data: tiposEventos,
          value: "id",
          desc: "nome",
        },
      },
      data: {
        label: "Data",
        type: "date",
        // value: isoToSqlDate(dataHoraAtual.toISOString()),
        required: true,
        space: 2,
      },
      hora: {
        label: "Hora",
        type: "number",
        // value: `${dataHoraAtual.getHours()}:${dataHoraAtual.getMinutes()}`,
        space: 1,
        // required: true,
      },
      minuto: {
        label: "Minutos",
        type: "number",
        // value: `${dataHoraAtual.getHours()}:${dataHoraAtual.getMinutes()}`,
        space: 1,
        // required: true,
      },
      anexo: {
        name: "Anexo",
        type: "file",
        space: 4,
      },
      anotacao: {
        label: "Anotação",
        type: "textarea",
        value: "",
      },
    },
    title: "Novo evento",
    submit: {
      label: "Inserir",
      action: inserirEvento,
    },
    close: {
      label: "fechar",
      action: () => setEventoSelecionado({}),
    },
  };

  const fSelecaoEdicao = {
    title: "Elemento a editar",
    form: edicaoPermitida
      ? {
          elemento: {
            label: "Elemento",
            type: "select",
            options: [
              {
                value: "FRETE",
                desc: "Frete",
              },
              {
                value: 'ITENS',
                desc: 'Itens/produtos',
              },
              {
                value: "PARCELAS",
                desc: "Parcelas",
              },
            ],
            emptyItem: true,
            emptyItemText: "(Selecione)",
            // required: true,
          },
        }
      : {
        elemento: {
          label: "Elemento",
          type: "select",
          options: [
            {
              value: "PARCELAS",
              desc: "Parcelas",
            },
          ],
          emptyItem: true,
          emptyItemText: "(Selecione)",
          // required: true,
        },
      },
    submit: {
      label: "Iniciar edição",
      action: (f) => setElementoEdicao(f.elemento),
    },

    close: {
      label: "fechar",
      action: () => setSelecaoEdicao(false),
    },
  };

  const fEscola = {
    title: "Escola/endereço de entrega",
    form: {
      nome: {
        label: "Nome da escola",
        type: "text",
        space: 6,
        readOnly: true,
        value: pedido.escolaNome,
      },
      municipio: {
        label: "Município",
        type: "text",
        space: 4,
        readOnly: true,
        value: pedido.escolaMunicipio,
      },
      UF: {
        label: "UF",
        type: "text",
        space: 2,
        readOnly: true,
        value: pedido.escolaUF,
      },
      logradouro: {
        label: "Logradouro",
        type: "text",
        space: 10,
        readOnly: true,
        value: pedido.escolaEnderecoLogradouro,
      },
      numero: {
        label: "Número",
        type: "text",
        space: 2,
        readOnly: true,
        value: pedido.escolaEnderecoNumero,
      },
      CEP: {
        label: "CEP",
        type: "text",
        space: 4,
        readOnly: true,
        value: pedido.escolaEnderecoCEP,
      },
      complemento: {
        label: "Complemento",
        type: "text",
        space: 4,
        readOnly: true,
        value: pedido.escolaEnderecoComplemento,
      },
      bairro: {
        label: "Bairro",
        type: "text",
        space: 4,
        readOnly: true,
        value: pedido.escolaEnderecoBairro,
      },
    },
  };

  const fRegistroPgtoExterno = {
    title: "Registro de pagamento externo/desconto",
    form: {
      operacao: {
        label: "Operação",
        type: "radiobutton",
        row: true,
        value: dadosRegistroPgtoExterno.operacao,
        space: 12,
        options: [
          {
            value: 1,
            desc: "Pagamento externo",
          },
          {
            value: 2,
            desc: "Desconto",
          },
        ],
        required: true
      },
      valor: {
        label: 'Valor (R$)',
        type: 'number',
        required: true,
        value: dadosRegistroPgtoExterno.valor
      },
      observacao: {
        label: "Observação",
        type: "textarea",
        value: dadosRegistroPgtoExterno.observacao
      },
      anexo: {
        label: "Anexo",
        type: "file",
        value: dadosRegistroPgtoExterno.anexo
      },
      opcaoParcelamento: {
        label: "Parcelamento do valor restante",
        type: "radiobutton",
        row: true,
        value: dadosRegistroPgtoExterno.opcaoParcelamento,
        space: 12,
        options: [
          {
            value: 1,
            desc: "Distribuir nos próximos meses de acordo com quantidade de parcelas do pedido",
          },
          {
            value: 2,
            desc: "Personalizar",
          },
        ],
        required: true,
      },
    },
    autoSave: salvarDadosFormPagtoExterno,
    submit: {
      label: 'Registrar pagamento/desconto',
      action: registrarPagamentoExterno
    },
    close: {
      label: 'Cancelar',
      action: () => setRegistroPgtoExterno(false)
    }
  };

  if(dadosRegistroPgtoExterno.opcaoParcelamento === '2'){
    fRegistroPgtoExterno.form.qtdParcelas = {
      label: "Quantidade de parcelas",
      type: "number",
      value: dadosRegistroPgtoExterno.qtdParcelas
        ? dadosRegistroPgtoExterno.qtdParcelas
        : 1,
      required: true,
      space: 6,
    };
    fRegistroPgtoExterno.form.mes = {
      label: "Mês de vencimento da 1ª parcela",
      type: "number",
      value: dadosRegistroPgtoExterno.mes
        ? dadosRegistroPgtoExterno.mes
        : mesAtual === 12
        ? 1
        : mesAtual + 1,
      required: true,
      space: 3,
    }
    fRegistroPgtoExterno.form.ano = {
      label: "Ano de vencimento da 1ª parcela",
      type: "number",
      value: dadosRegistroPgtoExterno.ano
        ? dadosRegistroPgtoExterno.ano
        : mesAtual === 12
        ? anoAtual + 1
        : anoAtual,
      required: true,
      space: 3,
    };
  }

  if(modoGerenciamentoPagamentos){
    return(
      <div>
        <Form formData={fPedidoGerenciamentoPgto} />
        {registroPgtoExterno ? 
          <Form formData={fRegistroPgtoExterno} />
        :
          <ActionTable structure={tbPagamentos} />
        }
      </div>
    )
  }

  return (
    <div>
      <Form formData={fPedido} />
      <Form formData={fEscola} />
      {selecaoEdicao ? (
        elementoEdicao ? (
          <Edicao
            pedido={pedido}
            elemento={elementoEdicao}
            fecharEdicao={() => setElementoEdicao("")}
            fecharSelecaoEdicao={() => setSelecaoEdicao("")}
            recarregar={() => carregarPedido()}
          />
        ) : (
          <>
            <p>
              <b>
                Obter ajuda:{" "}
                <a
                  target="_blank"
                  href="https://docs.google.com/document/d/1ekayUZDlVQEUWtd-XP_PkY2P6bdOMJosfDwRy92TBWE/edit?usp=sharing"
                >
                  Edição de pedidos
                </a>
              </b>
            </p>
            {edicaoPermitida ? null : <p>O pedido já possui parcela faturada/com boleto gerado, sendo permitida apenas a edição das parcelas em aberto.</p>}
            <Form formData={fSelecaoEdicao} />
          </>
        )
      ) : (
        <>
          <ActionTable structure={tRegistros} />

          {eventoSelecionado.id >= 0 ? (
            <Form formData={fNovoEvento} />
          ) : (
            <ActionTable structure={tbEventos} />
          )}
          <br />
          <ActionTable structure={tbPagamentos} />
        </>
      )}

      <Dialog
        open={pagamentoExternoCancelar}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Cancelar pagamento externo</DialogTitle>
        <DialogContent>
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            Deseja realmente cancelar o pagamento externo/desconto?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={cancelarPagamentoExterno}
          >
            Cancelar pagamento externo/desconto
          </Button>
          <Button variant="contained" onClick={() => setPagamentoExternoCancelar(0)}>
            Voltar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const modalidesPagamento = [
  {
    value: 1,
    desc: 'Boleto avulso'
  },
  {
    value: 2,
    desc: 'Cartão de crédito'
  },
  {
    value: 3,
    desc: 'PIX'
  },
  {
    value: 4,
    desc: 'Faturas (pedido padrão)'
  },
]